import {pick} from 'lodash'
import {isVideoItem, isSlideBackgroundItem} from 'powtoon-document'
import {getDefaultVideoPlaybackSettings} from 'powtoon-commons/models/utils/videoPlaybackSettings'

export default function lib2Background(type, data, currentSlideDuration) {
  if (type === 'libraryItem') {
    if (!isSlideBackgroundItem(data)) {
      const error = new Error('Wrong background itemType')
      throw error
    }

    const item = {
      contentItemId: data.id,
      itemType: data.itemType,
      ...pick(data, 'assetType', 'sourcePanel', 'isFlipped', 'blurLevel', 'opacity')
    }

    if (isVideoItem(data)) {
      item.playbackSettings = getDefaultVideoPlaybackSettings(data, 0, currentSlideDuration)
    }

    return item
  }
  else if (type === 'color') {
    return {
      itemType: 'color',
      color: data,
      opacity: 1
    }
  }
  return null
}
